


































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

export interface StepperInfo {
  identifier: string;
  title?: string;
}
export type StepperOptions = {
  dots_first: boolean;
  show_title: boolean;
  animated: boolean;
};

@Component
export default class Stepper extends Vue {
  @Prop({ required: true })
  private steps!: Array<StepperInfo | number>;

  @Prop({
    default: (): StepperOptions => ({
      dots_first: true,
      animated: false,
      show_title: false,
    }),
  })
  private options?: StepperOptions;

  @Prop({ required: true })
  private currentStep!: number;

  get working_steps(): Array<StepperInfo> {
    const firstStep: StepperInfo | number = this.steps[0];
    if (typeof firstStep === 'number') {
      return this.steps.map(
        (elm, index) =>
          ({
            identifier: `${index}`,
            title: (this.options?.show_title && `Passo ${index}`) || '',
          } as StepperInfo),
      );
    }
    return this.steps as Array<StepperInfo>;
  }

  private showDotInfo(step: StepperInfo, index: number) {
    return (this.options?.show_title && step.title) || index + 1;
  }

  private isActive(step: StepperInfo): boolean {
    return this.currentStep === this.working_steps.findIndex((elm) => elm.identifier === step.identifier);
  }

  private isCompleted(step: StepperInfo | number): boolean {
    const indexStep = this.working_steps.findIndex(
      (elm, index) => (typeof step !== 'number' && elm.identifier === step.identifier) || index === step,
    );
    const indexCurrentStep = this.working_steps.findIndex((elm, index) => index === this.currentStep);
    return indexCurrentStep > indexStep;
  }

  private get on_last_step(): boolean {
    return this.currentStep === this.working_steps.length - 1;
  }

  public nextPrev(step: StepperInfo | number) {
    if (this.on_last_step && step === this.working_steps.length) {
      return this.$emit('finish');
    }

    const stepIsStepperInfo = (step: StepperInfo | number): step is StepperInfo => !!(step as StepperInfo)?.identifier;

    const index = this.working_steps.findIndex(
      (elm, index) => (stepIsStepperInfo(step) && step.identifier === elm.identifier) || step === index,
    );

    this.$emit('current-step', index);
  }

  @Emit()
  onChangeStep(index: number) {
    return index;
  }
}
